//
// Project Card
//
// ---------------------------------------------------------------------------

'use strict';

const config = {
    projectSelector: '.js-project-card',
    lifeCycleSelector: '.js-project-card-lifecycle',
    lifetimeRiskSelector: '.js-project-card-lifetime-risk',
    lifecycleAndLifetimeRiskUrlData: 'lifecycle-and-lifetime-risk-url',
    pillClassName: 'c-pill',
    riskClassName: 'c-risk',
    pillSelector: '.c-pill',
    riskSelector: '.c-risk',
    projectIdAttr: 'project-id',
    spinnerClass: 'is-loading'
};

class ProjectCard {

    /**
     * @param {jQuery} $elt The element for the component.
     */
    constructor($elt) {
        this.bindElements($elt);
    }

    /**
     * Bind common elements
     * @param {jQuery} $elt The element for the component.
     */
    bindElements($elt) {
        this.card = $elt;
    }

    /**
     * Loads lifecycle and lifetime risk data on load
     * @returns {Promise}
     */
    loadLifecycleAndLifetimeRisk() {

        const ProjectCard = this;
        const url = ProjectCard.card.data(config.lifecycleAndLifetimeRiskUrlData);
        const fragment = document.createDocumentFragment();
        const projectId = ProjectCard.card.data(config.projectIdAttr);

        const lifecycle = ProjectCard.card.find(config.lifeCycleSelector);
        const lifecyclePill = lifecycle.find(config.pillSelector);

        const lifetimeRisk = ProjectCard.card.find(config.lifetimeRiskSelector);
        const lifetimeRiskElement = lifetimeRisk.find(config.riskSelector);

        const params = {
            projectId: projectId
        }; // For these params, when data is not supplied, these are null and will not be sent in the ajax call

        if (!url) {
            return;
        }

        lifecyclePill.addClass(config.spinnerClass);

        let lifetimeRiskElementCache = '';

        lifetimeRiskElementCache = lifetimeRiskElement.contents();
        lifetimeRiskElement.empty();
        lifetimeRiskElement.addClass(config.spinnerClass);

        return $.get(url, params, function(response) {
            replaceLifecyclePill(response);
            replaceRisk(response);
        }).fail(function () {
            lifetimeRiskElement.append(lifetimeRiskElementCache);
        }).always(function () {
            lifecyclePill.removeClass(config.spinnerClass);
            lifetimeRiskElementCache = '';
            lifetimeRiskElement.removeClass(config.spinnerClass);
        });

        /**
         * Handler replacing the lifecycle pill
         *
         * @param {Object} response
         */
        function replaceLifecyclePill(response) {

            const newPill = $(response).find(config.pillSelector);

            if (newPill.hasClass(config.pillClassName)) {
                fragment.appendChild(newPill[0]);
                lifecyclePill.replaceWith(fragment);
            }
        }

        /**
         * Handler replacing the risk element
         *
         * @param {Object} response
         */
        function replaceRisk(response) {

            const newRisk = $(response).find(config.riskSelector);

            if (newRisk.hasClass(config.riskClassName)) {
                fragment.appendChild(newRisk[0]);
                lifetimeRiskElement.replaceWith(fragment);
            }
        }
    }
}

$(window).load(function() {

    let projects = [];

    $(config.projectSelector).each(function () {
        projects.push($(this));
    });

    let loop = function(i) {
        let num = i || 0;

        if (projects[num]) {
            let pc = new ProjectCard(projects[num]);

            $.when(pc.loadLifecycleAndLifetimeRisk()).always(function() {
                loop(num + 1);
            });
        }
    };

    loop();
});



// WEBPACK FOOTER //
// ./src/js/components/project-card.js